import { ButtonTriggerEvent } from '../../../common/components';

export class ShowImageModalActions {
  confirm: (event: ButtonTriggerEvent, image: string) => void;
  cancel?: () => void;
}

export class ShowImageModalData {
  data: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.image.modal/show.image.modal.provider.ts